import { render, staticRenderFns } from "./updates-source.vue?vue&type=template&id=2467b754"
import script from "./updates-source.vue?vue&type=script&lang=js"
export * from "./updates-source.vue?vue&type=script&lang=js"
import style0 from "./updates-source.vue?vue&type=style&index=0&id=2467b754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/app/components/ui/Avatar.vue').default})
